import CopiableInput from "common/components/CopiableInput";
import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import useWorkspaceToken from "common/datahooks/useWorkspaceToken";
import useCopyText from "common/hooks/useCopyText";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

const brandUrl = import.meta.env.VITE_WHITE_LABEL_URL;

interface BrandedLoginUrlProps {
  goBack: () => void;
  accountId?: string;
  accountFullName?: string;
}

export default function BrandedLoginUrl({
  goBack,
  accountId = null,
  accountFullName = null,
}: BrandedLoginUrlProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { workspaceToken, isLoadingWorkspaceToken, workspaceTokenError } =
    useWorkspaceToken({
      accountId,
    });

  const URL = workspaceToken
    ? `${brandUrl}${workspaceToken ? `#${workspaceToken}` : ""}`
    : undefined;

  const { isCopied, copyText } = useCopyText(URL);

  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={
          <>
            {accountId ? "Reconnect" : "Connect"} URL
            {accountFullName && ` for ${accountFullName}`}
          </>
        }
      />

      <Body>
        <FormField
          label="URL"
          size={isDesktop ? "md" : "lg"}
          htmlFor="brandedLoginUrl"
          error={workspaceTokenError?.message}
          hint={
            !!accountId &&
            "This generates a reconnect link for this specific account"
          }
        >
          <CopiableInput
            value={isLoadingWorkspaceToken ? "Generating link..." : URL}
            id="brandedLoginUrl"
            variant={isDesktop ? "md" : "lg"}
            isLoading={isLoadingWorkspaceToken}
          />
        </FormField>
      </Body>

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={goBack}>
          Cancel
        </Button>

        <Button
          onClick={copyText}
          isLoading={isLoadingWorkspaceToken}
          disabled={!URL}
        >
          {isCopied ? "Copied!" : "Copy link"}
        </Button>
      </Footer>
    </>
  );
}
